import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import i18next from "i18next";
import { AlertTriangle } from "lucide-react";
import { cn } from "../../../../utils";
import { renderFallback } from "../utils";
import { getDueDateUrgency } from "@bliks-io/contracts";
import { createColumnHeader } from "./column-header";
const dueDateUrgencyClassName = {
    normal: "",
    warning: "text-warning",
    overdue: "text-danger",
    critical: "text-danger font-semibold"
};
export function createDueDateColumn(title, standardRecordingTimeMs) {
    return {
        id: "dueDate",
        accessorKey: "dueDate",
        meta: {
            label: title
        },
        header: createColumnHeader(title),
        cell: ({ row })=>{
            const dueDate = row.original.dueDate;
            if (!dueDate) return renderFallback(null);
            const urgency = getDueDateUrgency(dueDate, standardRecordingTimeMs);
            return /*#__PURE__*/ _jsxs("span", {
                className: cn("text-sm", dueDateUrgencyClassName[urgency]),
                children: [
                    urgency === "critical" && /*#__PURE__*/ _jsx(AlertTriangle, {
                        className: "inline-block h-3.5 w-3.5 mr-1 align-text-bottom"
                    }),
                    new Date(dueDate).toLocaleString(i18next.language, {
                        year: "numeric",
                        month: "short",
                        day: "numeric",
                        hour: "2-digit",
                        minute: "2-digit"
                    })
                ]
            });
        },
        enableSorting: true
    };
}

//# sourceMappingURL=due-date-column.js.map